import React, { useEffect, useReducer} from 'react';
import {Container, Row,Button, Nav} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"

const Boardofdirectors = () => {
    useEffect(() =>{
        document.title = "Board of Directors | Rich-Oak Group"
    },[])

    return (
      
      <div>





<div className="homepageslider" id="homepageslider">
<Header/>
{/* <Container className=''> */}


<div  id="bodfirstbox">
    <Row >
    <div className="col-lg-7 col-md-12">
        <div className='hmfirstinnerbox'>
        <h3 className="hmfirstboxheading">Board of Directors</h3>
        <p className='description hmfirstboxdescription'>
        Rich-Oak invests in building businesses that can produce long-term competitive advantage which yields competitive returns, improve lives and economic growth for our investors, customers and other stakeholders.

        </p>
        
       
  
        </div>
    </div>
    </Row>
    </div>




    <div className='hmtenthbox'>
        <Row>
            <div className='col-md-12'>
            <p className="whatwedohead">Board of <span style={{color:"#D80032"}}>Directors</span> </p>
           <hr class="whatwedohr"/>
            <p className="whatwedobody">
            We are governed by a board comprising of non-executive directors
and executive directors. 
                </p>
            </div>
        </Row>
      
    </div>

    <div className='hmlastbox'>
  
        <Row>

        <div className='col-lg-3 col-md-5'>

            <p class="centermobile"> 
            <img class="staffimage" style={{borderRadius:"15px"}}  src="images/staff/fagbeyi.jpeg"/> </p>
                        <p className="whatwedolastboxhead2 centermobile">Fagbemi<span style={{color:"#D80032"}}> Omoniyi </span> </p>
                        <p  className="whatwedolastboxbody centermobile">FCA, ACTI, MBA, MNI (Consultant)(Chairman).</p>
                        {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}
            
                        </div>

                        <div class="col-lg-1 col-md-1"></div>
            
                        <div className='col-lg-3 col-md-5'>
            

            <div className="margintop50mobile">
            <p class="centermobile"> 
            <img style={{borderRadius:"15px"}}  class="staffimage" src="images/staff/otive.jpeg"/> </p>
                        <p className="whatwedolastboxhead2 centermobile">Dr Otive<span style={{color:"#D80032"}}> Igbuzor </span> </p>
                        <p  className="whatwedolastboxbody centermobile">(Non-Executive Director)</p>
                        {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}
            
                        </div>
                        </div>

                        <div class="col-lg-1 col-md-1"></div>

                        <div className='col-lg-3 col-md-5'>
            

            <div className="margintop50mobile">
            <p class="centermobile"> <img style={{borderRadius:"15px"}} class="staffimage" src="images/staff/pius.jpeg"/> </p>
                        <p className="whatwedolastboxhead2 centermobile">Pius<span style={{color:"#D80032"}}> Ukwah </span> </p>
                        <p  className="whatwedolastboxbody centermobile">(ACA, MBA-in view) (Non-Executive Director)</p>
                        {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}
            
                        </div>
                        </div>

                        <div class="col-lg-1 col-md-1"></div>

        <div className='col-lg-3 col-md-5'>
            

            <div className="">
            <p class="centermobile"><img class="staffimage" style={{borderRadius:"15px"}} src="images/staff/williams.jpg"/> </p>
                        <p className="whatwedolastboxhead2 centermobile">Williams<span style={{color:"#D80032"}}> Olatunbosun </span> </p>
                        <p  className="whatwedolastboxbody centermobile">Executive Director.</p>
                        {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}
            
                        </div>
                        </div>

                        <div class="col-lg-1 col-md-1"></div>
            
                        <div className='col-lg-3 col-md-5'>
            

            {/* <div className="margintop50mobile">
           <p class="centermobile"><img class="staffimage" style={{borderRadius:"15px"}} src="images/bod5.jpeg"/> </p> 
                        <p className="whatwedolastboxhead2 centermobile">Oluwatosin<span style={{color:"#D80032"}}> Idu-Okojokwu </span> </p>
                        <p  className="whatwedolastboxbody centermobile">(Executive Director)</p>
            
                        </div> */}
                        </div>
                        <div class="col-lg-1 col-md-1"></div>
 
                      
                        <Row/>




               
               
                
            </Row>


          

      
    </div>

    {/* <div className='hmtenthbox'>
        <Row>
            <div className='col-md-12'>
            <p className="whatwedohead">Management </p>
           <hr class="whatwedohr"/>
            <p className="whatwedobody">
            We are governed by a board comprising of non-executive directors
and executive directors. 
                </p>
            </div>
        </Row>
      
    </div> */}

    <div className='hmlastbox'>
  
        <Row>

        <div className='col-lg-3 col-md-5'>
            

            {/* <div className="">
            <p class="centermobile"><img class="staffimage" style={{borderRadius:"15px"}}  src="images/staff/blessing.jpg"/> </p>
                        <p className="whatwedolastboxhead2 centermobile">Okekwue<span style={{color:"#D80032"}}> Blessing </span> </p>
                        <p  className="whatwedolastboxbody centermobile">HR/Legal</p>
            
                        </div> */}
                        </div>

                        <div class="col-lg-1 col-md-1"></div>
            
                        <div className='col-lg-3 col-md-5'>
            

            {/* <div className="margintop50mobile">
            <p class="centermobile">  <img class="staffimage"style={{borderRadius:"15px"}} src="images/staff/samuel.jpg"/> </p>
                        <p className="whatwedolastboxhead2 centermobile">Makinde<span style={{color:"#D80032"}}> Samuel </span> </p>
                        <p  className="whatwedolastboxbody centermobile">Head, Credit.</p>
            
                        </div> */}
                        </div>
                        <div class="col-lg-1 col-md-1"></div>
                        <div className='col-lg-3 col-md-3'>
            

                        {/* <div className="margintop50mobile">
            <p class="centermobile">  <img class="staffimage"style={{borderRadius:"15px"}} src="images/staff/hezekiah.jpg"/> </p>
                        <p className="whatwedolastboxhead2 centermobile">Hezekiah<span style={{color:"#D80032"}}> Agbai </span> </p>
                        <p  className="whatwedolastboxbody centermobile">Head, Internal Control.</p>
            
                        </div> */}
                        </div>


                        <Row/>




               
               
                
            </Row>

            <Row>

<div className='col-lg-3 col-md-5'>
    

    {/* <div className="">
    <p class="centermobile"><img class="staffimage" style={{borderRadius:"15px"}}  src="images/staff/alex.jpg"/> </p>
                <p className="whatwedolastboxhead2 centermobile">Alexandra<span style={{color:"#D80032"}}> Azonobo </span> </p>
                <p  className="whatwedolastboxbody centermobile">Head, Investment</p>
    
                </div> */}
                </div>

                <div class="col-lg-1 col-md-1"></div>
    
                <div className='col-lg-3 col-md-5'>
    

    {/* <div className="margintop50mobile">
    <p class="centermobile">  <img class="staffimage"style={{borderRadius:"15px"}} src="images/staff/rebecca.jpg"/> </p>
                <p className="whatwedolastboxhead2 centermobile">Rebecca<span style={{color:"#D80032"}}> Ogundele </span> </p>
                <p  className="whatwedolastboxbody centermobile">Head, Account.</p>
    
                </div> */}
                </div>
                <div class="col-lg-1 col-md-1"></div>
                <div className='col-lg-3 col-md-3'>
    
                {/* <div className="margintop50mobile">
    <p class="centermobile">  <img class="staffimage"style={{borderRadius:"15px"}} src="images/staff/ayo.jpg"/> </p>
                <p className="whatwedolastboxhead2 centermobile">Ayomide<span style={{color:"#D80032"}}> Adeniyi </span> </p>
                <p  className="whatwedolastboxbody centermobile">Technical Lead.</p>
    
                </div> */}
                </div>


                <Row/>




       
       
        
    </Row>

       

      
    </div>




    {/* <div className='hmfourthbox'>
    <div className=''>

            <Row>
                <div className='col-md-4'>
        <p className='hmcia fordesktoponly'>Current
       <span style={{color:"#D80032"}} > Investment</span> <br/>
        Allocation
        </p>

        <p className='hmcia formobileonly'>Current
       <span style={{color:"#D80032"}} > Investment</span> <br/>
        Allocation
        </p>
        <p  className="hmwwdp"></p>
        <p className='hmfourthboxinner hmfourthboxinner1 '>
        We are building long-term relationships with our clients, partnering with individuals and institutions to achieve long term financial growth.
        </p>
                    </div>


                    <div className='col-md-4 hciabox1'>
                  
                        <p className='ciaimagebox'><img src="images/homeicon.png"/> <span><img style={{float:"right", paddingTop:"14px"}} src="images/arrow_forward.png"/> </span></p>
                        <p className="hmciahead">Real estate</p>
                        <p  className='hmfourthboxinner'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus elementum lectus augue euismod faucibus.</p>
                    </div>

        

                    <div className='col-md-4 hciabox2'>
                    <p className='ciaimagebox'><img src="images/homeicon.png"/> <span><img style={{float:"right", paddingTop:"14px"}}src="images/arrow_forward.png"/> </span></p>
                        <p className="hmciahead">Credit Investment</p>
                        <p  className='hmfourthboxinner'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus elementum lectus augue euismod faucibus.</p>
                    </div>

               
               
                
            </Row>

            <Row className="ciasecondbox">
                <div className='col-md-4'>

                    </div>


                    <div className='col-md-4 hciabox2'>
                        <p className='ciaimagebox'><img src="images/homeicon.png"/> <span><img style={{float:"right", paddingTop:"14px"}}src="images/arrow_forward.png"/> </span></p>
                        <p className="hmciahead">Agriculture</p>
                        <p   className='hmfourthboxinner2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus elementum lectus augue euismod faucibus.</p>
                    </div>

            

                    <div className='col-md-4 hciabox1'>
                    <p className='ciaimagebox'><img src="images/homeicon.png"/> <span><img style={{float:"right", paddingTop:"14px"}}src="images/arrow_forward.png"/> </span></p>
                        <p className="hmciahead">Real estate</p>
                        <p   className='hmfourthboxinner2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus elementum lectus augue euismod faucibus.</p>
                    </div>

               
               
                
            </Row>
   
        </div>
    </div> */}

 



    {/* <div className='hmseventhbox'>
    <div className=''>
    <h1 className="hmwwd2 fordesktoponly">Creating a great <span style={{color:"#D80032"}}>experience for you<br/></span> begins with  a conversation.</h1>
    <h1 className="hmwwd2 formobileonly">Creating a great <span style={{color:"#D80032"}}>experience for you </span> begins with a conversation.</h1>

            <hr class="hpwwdhr3"/>
       
            <Row className="innerboxseven">
        

                <div className='col-md-5'>
                    <h1 className='hmwwd2head'>Contact Info</h1>
                    <p className='innerboxsevendescription'>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu leo cras in blandit mauris. Sociis dignissim luctus arcu lectus justo, vitae laoreet.
                    </p>

<div className='innersesventhbody'>
                    <Row>
                        <div class="col-lg-1 col-md-2">
                            <img src="images/icons/phone.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <h1 className='innerboxsevendescriptionicon'>Phone number</h1>
                            <p className='innerboxsevendescriptiontext'>+234 123 456 7890, +234 123 456 7890</p>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                    <div class="col-lg-1 col-md-2">
                            <img src="images/icons/mail.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Email address</p>
                            <p className='innerboxsevendescriptiontext'>samplemail@rich-oaks.com<br/> anothersamplemail2@rich-oaks.com</p>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                    <div class="col-lg-1 col-md-2">
                            <img src="images/icons/office.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Address</p>
                            <p className='innerboxsevendescriptiontext'>Plot 1072 Grand Pela Hotel Street, Durumi Area 1. Abuja</p>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                        <div class="col-lg-1 col-md-2">
                            <img src="images/icons/clock.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Office Hours</p>
                            <p className='innerboxsevendescriptiontext'>Mondays - Fridays: 9am - 5pm</p>
                        </div>
                    </Row>
                    </div>

                </div>
<hr className="hrmobile formobileonly"/>
                    <div className='col-md-1'></div>

                    <div className='col-md-5'>
                    <h1 className='hmwwd2head hmwwd2headmobile'>You can reach out to us</h1>

                    <p className='innerboxsevendescription'>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu leo cras in blandit mauris. Sociis dignissim luctus arcu lectus justo, vitae laoreet.
                                          </p>

                                          <form className='hmformmobile'>
  <div class="form-group">
    <label className='hmlabel' for="">Full Name</label>
    <input type="email" class="form-control form-control-lg hminput" id=""placeholder="Enter email"/>
  </div>


  <div class="form-group">
    <label className='hmlabel hmlabel2' for="">Email Address</label>
    <input type="password" class="form-control form-control-lg hminput" id="" placeholder="Password"/>
  </div>

  <div class="form-group">
    <label className='hmlabel hmlabel2' for="">Message</label>
    <textarea class="form-control hminput" id="" rows="6"></textarea>
  </div>

  <button type="submit" class="hmfirstboxbutton">SEND YOUR MESSAGE</button>
</form>
                  
                    </div>

            
                  
                 
            </Row>
        </div>
    </div> */}

 

<br/>
<br/>


    </div>

<div id="homepagethirdbox">
    

</div>






    <Footer/>
    </div>


    )
    
    
}


export {Boardofdirectors as default}